import axios from "axios";
import store from '../store/index';

const jwtInterceptor = axios.create({});


jwtInterceptor.interceptors.request.use((config) =>
{
  const authData = store.getters["auth/getAuthData"];
  if (authData == null)
  {
    return config;
  }

  config.headers.common["Authorization"] = `bearer ${authData.token}`;
  return config;
});

jwtInterceptor.interceptors.response.use(
  (response) =>
  {
    return response;
  },
  async (error) =>
  {
    if (error.response.status === 401)
    {
      const authData = store.getters["auth/getAuthData"];
      const payload = {
        access_token: authData.token,
        refresh_token: authData.refreshToken,
      };

      const url = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + 'user/refreshToken';
      try
      {
        var response = await axios.post(
          url,
          payload
        );
        if (response.ok)
        {
          const authResultData = {
            access_token: response.data.token.token,
            refresh_token: response.data.token.refreshToken
          }
          await store.dispatch("auth/saveTokensToStorage", authResultData);
          error.config.headers[
            "Authorization"
            ] = `bearer ${response.data.access_token}`;
          return axios(error.config);
        }
        if (window.location.pathname!=='/Login')
          window.location.replace('/Login');
        return null;
      }
      catch (e)
      {
        console.log(e)
      }
    }
    else
    {
      /**
       * ToDo
       *  show Toast
       */
      return Promise.reject(error);
    }
  }
);

export default jwtInterceptor;